import Container from 'react-bootstrap/Container';

import './About.css';


export function About(props) {
    return (
        <Container>
            <div className="info-panel">
                <h1>Mission Statement</h1>
                <p>The mission of Choice Social Club is to empower consenting, adventurous, open-minded adults to explore all of the choices that the gamut of human sexuality has to offer, both with their partners and with other desirable and like-minded people. Everyone has their own favorite fantasies and turn-ons, and it is our mission to provide an upscale, clean, comfortable and discreet environment for you to safely enjoy exploring the boundaries of your favorite flavor of spice.</p>
                <p>It is our goal for you to integrate into our community and feel at home with our members and at our club.</p>
            </div>
            <div className="info-panel">
                <h1>Our Community</h1>
                <p>Choice Social Club is an adult lifestyles club that caters to many different aspects of adult sexuality. Traditional swingers' parties primarily cater to heterosexual encounters between couples, or couples and single females. Generally speaking, traditional swingers will enjoy our venue very much, but additionally, our adult lifestyles club takes it a bit further and welcomes human sexuality in all its forms. As an adult lifestyles club, we attract people who identify as heterosexual, bisexual, transgendered, and gay. Our members are interested in swing, voyeurism, exhibitionism, and fetish play (bd/sm, body worship, and just about anything else that's legal!).</p>
                <p>Having said that, all members respect one another at Choice. Boundaries and individual fantasies and desires are equally respected, and there is no pressure for any individual to participate in any behavior specifically not his or her fantasy. Our members are kind, respectful and non-judgmental about the turn-ons of their fellow members.</p>
                <p>Our club is the venue of choice for discriminating, adventurous adults, particularly those who place high value on discretion and safety. Executing a privacy agreement is a requirement at Choice, and prospective members are screened to ensure that all applicants fully understand the nature of the club and that all parties applying for membership truly wish to be a part of our community. We welcome couples, single females, and single males, and invite you to review our membership policies for further information.</p>
                <p>Choice Social Club offers an upscale, comfortable and elegant place for our members to meet, socialize and play. We would love for you to join us.</p>
            </div>
        </Container>
    );

}






            // <Nav tabs>
            //     <NavItem>
            //         <NavLink
            //             className={classnames({ active: this.state.activeTab === '1' })}
            //             onClick={() => { this.setTab('1'); }}
            //         >
            //             Couples
            //         </NavLink>
            //     </NavItem>
            //     <NavItem>
            //         <NavLink
            //             className={classnames({ active: this.state.activeTab === '2' })}
            //             onClick={() => { this.setTab('2'); }}
            //         >
            //             Single Women
            //         </NavLink>
            //     </NavItem>
            //     <NavItem>
            //         <NavLink
            //             className={classnames({ active: this.state.activeTab === '3' })}
            //             onClick={() => { this.setTab('3'); }}
            //         >
            //             Single Men
            //         </NavLink>
            //     </NavItem>
            // </Nav>

            // <TabContent className="border-left border-right border-bottom p-3" activeTab={this.state.activeTab}>

            //     <TabPane tabId="1">
            //         <h4>Membership Options for Couples</h4>

            //         <CouplesTable rows={couplesMemberships} />

            //         <p>We are now offering a special 1-day couples pass for $90.  You still need to complete an online membership application and sign a privacy agreement, but this will allow you to attend an event to see if the club is right for you without paying for the membership/application fee - This is also a great option for couples traveling to and visiting the area.</p>
            //         <p>If you decide to return (we know you will!), at your next event you will then pay for your membership/application fee and the normal event pricing.</p>
            //         <p>Please <Link to="contact.php">contact us</Link> for information about additional membership terms</p>
            //     </TabPane>


            //     <TabPane tabId="2">
            //         <h4>Membership Options for Single Women</h4>
            //     </TabPane>


            //     <TabPane tabId="3">
            //         <h4>Membership Options for Single Men</h4>

            //     </TabPane>
            // </TabContent>

